import React from "react";
import { Button, Dialog, DialogTitle, Stack } from "@mui/material";
import { dialogueTitleStyle } from "../../styles/MUI-style-constants.js";
import "../../styles/generate-captions.scss";
import "../../styles/global.scss";

const SocialSuiteMessage = (props) => {
  const handleClose = () => {
    props.setShowSocialSuiteLink(false);
  };

  const handleClick = () => {
    props.setShowSocialSuiteLink(false);
    window.open("https://www.cloudcampaign.com/get-started", "_blank");
  };

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle style={dialogueTitleStyle}>
          {
            "Start a free trial of Cloud Campaign, our social media scheduling suite, to schedule content in bulk with a CSV"
          } 
        </DialogTitle>
        <Stack direction="row" justifyContent="space-evenly" margin={2}>
          <Button variant="outlined" color="cc" onClick={handleClose}>
            No Thanks
          </Button>
          <Button variant="contained" color="cc" onClick={handleClick}>
            Start a Free Trial
          </Button>
        </Stack>
      </Dialog>
    </div>
  );
};

export default SocialSuiteMessage;
